{
  "COMPOSE_REDIRECT": {
    "OPENING": "Άνοιγμα νέας συνομιλίας με {email}…",
    "NO_EMAIL": "Δεν δόθηκε διεύθυνση email. Χρησιμοποιήστε ?email=name@example.com",
    "CONTACT_ERROR": "Δεν ήταν δυνατή η αναζήτηση της επαφής για {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Παρακαλώ επιλέξτε συζήτηση από το αριστερό τμήμα",
    "CSAT_REPLY_MESSAGE": "Παρακαλώ αξιολογήστε τη συνομιλία",
    "404": "Λυπούμαστε, δεν μπορούμε να βρούμε την συνομιλία. Παρακαλώ προσπαθήστε ξανά",
    "SWITCH_VIEW_LAYOUT": "Εναλλαγή διάταξης",
    "DASHBOARD_APP_TAB_MESSAGES": "Μηνύματα",
    "UNVERIFIED_SESSION": "Η ταυτότητα αυτού του χρήστη δεν επαληθεύεται",
    "NO_MESSAGE_1": "Ωχ ωχ! Φαίνεται ότι δεν υπάρχουν μηνύματα από τους πελάτες στα εισερχόμενά σας.",
    "NO_MESSAGE_2": " για να στείλετε ένα μήνυμα στην σελίδα σας!",
    "NO_INBOX_1": "Γεια σας! Δεν έχετε προσθέσει κάποιο κιβώτιο εισερχομένων ακόμη.",
    "NO_INBOX_2": " για να ξεκινήσετε",
    "NO_INBOX_AGENT": "Ω όχι! Φαίνεται ότι δεν είστε μέλος κάποιου κιβωτίου εισερχμένων. Απευθυνθείτε στον διαχειριστή",
    "SEARCH_MESSAGES": "Αναζήτηση μηνυμάτων στις συνομιλίες",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Μετάφραση",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Αναζήτηση μηνυμάτων",
      "RESULT_TITLE": "Αποτελέσματα Αναζήτησης",
      "LOADING_MESSAGE": "Σύμπτυξη δεδομένων...",
      "PLACEHOLDER": "Εισάγετε κείμενο για αναζήτηση μηνυμάτων",
      "NO_MATCHING_RESULTS": "Δεν βρέθηκαν αποτελέσματα."
    },
    "UNREAD_MESSAGES": "Μη αναγνωσμένα μηνύματα",
    "UNREAD_MESSAGE": "Μη αναγνωσμένο μήνυμα",
    "CLICK_HERE": "Πατήστε εδώ",
    "LOADING_INBOXES": "Φόρτωση εισερχομένων",
    "LOADING_CONVERSATIONS": "Φόρτωση Συζητήσεων",
    "CANNOT_REPLY": "Δεν μπορείτε να απαντήσετε εξαιτίας",
    "24_HOURS_WINDOW": "του περιορισμού των 24 ωρών",
    "NOT_ASSIGNED_TO_YOU": "Αυτή η συνομιλία δεν έχει ανατεθεί σε εσάς. Θα θέλατε να αντιστοιχίσετε αυτή τη συνομιλία στον εαυτό σας;",
    "ASSIGN_TO_ME": "Ανάθεση σε μένα",
    "TWILIO_WHATSAPP_CAN_REPLY": "Μπορείτε να απαντήσετε μόνο σε αυτή τη συνομιλία χρησιμοποιώντας ένα πρότυπο μήνυμα επειδή",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "του περιορισμού των 24 ωρών",
    "REPLYING_TO": "Απαντάτε στο:",
    "REMOVE_SELECTION": "Διαγραφή Επιλογής",
    "DOWNLOAD": "Κατέβασμα",
    "UNKNOWN_FILE_TYPE": "Άγνωστο Αρχείο",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Πριν από την αποστολή, εκτελέστε:",
      "EXECUTE": "Εκτέλεση",
      "RETRY": "Δοκιμάστε ξανά",
      "CONFIRM": "Εκτέλεση τώρα;",
      "CONFIRM_YES": "Ναι, εκτέλεση",
      "CONFIRM_NO": "Ακύρωση",
      "RUNNING": "Εκτελείται…",
      "DONE": "Ολοκληρώθηκε",
      "CLAIM_DELAYED": "θα καταχωριστεί μόλις παραδοθεί η παραγγελία",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Δημιουργήθηκε ΝΕΟ αίτημα {reference}, το {planned} έχει κλείσει — επεξεργαστείτε το κείμενο του προσχεδίου",
        "NEW_CLAIM": "Δημιουργήθηκε ΝΕΟ αίτημα {reference} αντί για ενημέρωση του {planned} — επεξεργαστείτε το κείμενο του προσχεδίου",
        "OTHER_CLAIM": "Ενημερώθηκε το αίτημα {reference} αντί για το {planned} — επεξεργαστείτε το κείμενο του προσχεδίου",
        "EXISTING_CLAIM": "Δεν δημιουργήθηκε νέο αίτημα, ενημερώθηκε το υπάρχον {reference} — επεξεργαστείτε το κείμενο του προσχεδίου",
        "OTHER": "Η εξέλιξη ήταν διαφορετική από αυτή που υπέθετε το προσχέδιο — επεξεργαστείτε το κείμενο του προσχεδίου"
      },
      "FAILED": "Απέτυχε",
      "UNREACHABLE": "Το bot δεν είναι διαθέσιμο",
      "REQUEST_FAILED": "Δεν ήταν δυνατή η εκκίνηση της ενέργειας, δοκιμάστε ξανά.",
      "ACTIONS": {
        "CANCEL_ORDER": "Ακυρώστε την παραγγελία",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Αλλάξτε την πληρωμή σε αντικαταβολή",
        "CREATE_CLAIM": "Υποβάλετε αίτημα επιστροφής ή αντικατάστασης",
        "CREATE_OR_UPDATE_CLAIM": "Υποβάλετε ή ενημερώστε αίτημα επιστροφής ή αντικατάστασης",
        "EXTEND_ORDER_PICKUP_DATE": "Παρατείνετε την προθεσμία παραλαβής"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Ανέβασμα επισυναπτόμενων...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Το μήνυμα διαγράφηκε επιτυχώς",
    "FAIL_DELETE_MESSSAGE": "Δεν ήταν δυνατή η διαγραφή μηνύματος! Προσπαθήστε ξανά",
    "NO_RESPONSE": "Καμία ανταπόκριση",
    "RESPONSE": "Response",
    "RATING_TITLE": "Αξιολόγηση",
    "FEEDBACK_TITLE": "Ανατροφοδότηση",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Προβολή ετικετών",
      "HIDE_LABELS": "Απόκρυψη ετικετών"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Επίλυση",
      "REOPEN_ACTION": "Επαναφορά",
      "OPEN_ACTION": "Ανοιχτές",
      "OPEN": "Περισσότερα",
      "CLOSE": "Κλείσιμο",
      "DETAILS": "Λεπτομέρειες",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Αναβλήθηκε μέχρι αύριο",
      "SNOOZED_UNTIL_NEXT_WEEK": "Αναβολή έως την επόμενη εβδομάδα",
      "SNOOZED_UNTIL_NEXT_REPLY": "Αναβολή έως την επόμενη απάντηση",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Σήμανση ως εκκρεμής",
      "SNOOZE_UNTIL": "Αναβολή",
      "SNOOZE": {
        "TITLE": "Αναβολή έως",
        "NEXT_REPLY": "Επόμενη απάντηση",
        "TOMORROW": "Αύριο",
        "NEXT_WEEK": "Επόμενη εβδομάδα"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Αναβολή έως",
      "APPLY": "Αναβολή",
      "CANCEL": "Άκυρο"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "Κανένα",
        "URGENT": "Επείγον",
        "HIGH": "Υψηλή",
        "MEDIUM": "Μεσαία",
        "LOW": "Χαμηλή"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Κανένα",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "Δεν βρέθηκαν αποτελέσματα",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Άνοιγμα σε νέα καρτέλα",
      "COPY_LINK": "Αντιγραφή συνδέσμου συνομιλίας",
      "COPY_LINK_SUCCESS": "Ο σύνδεσμος της συνομιλίας αντιγράφηκε στο πρόχειρο",
      "PENDING": "Σήμανση ως εκκρεμής",
      "RESOLVED": "Σήμανση ως επιλυμένου",
      "MARK_AS_UNREAD": "Σήμανση ως μη αναγνωσμένο",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Άνοιγμα συνομιλίας",
      "SNOOZE": {
        "TITLE": "Αναβολή",
        "NEXT_REPLY": "Μέχρι την επόμενη απάντηση",
        "TOMORROW": "Μέχρι αύριο",
        "NEXT_WEEK": "Έως την επόμενη εβδομάδα"
      },
      "ASSIGN_AGENT": "Ανάθεση σε πράκτορα",
      "ASSIGN_LABEL": "Εκχώρηση ετικέτας",
      "AGENTS_LOADING": "Φόρτωση πρακτόρων...",
      "ASSIGN_TEAM": "Ανάθεση ομάδας",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Η συνομιλία με αριθμό {conversationId} ανατέθηκε στον \"{agentName}\"",
          "FAILED": "Αδυναμία αντιστοίχισης σε πράκτορα. Παρακαλώ δοκιμάστε ξανά."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Αποτυχία στην εκχώρηση ετικέτας, παρακαλώ δοκιμάστε αργότερα."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Η συνομιλία με αριθμό {conversationId} ανατέθηκε στην ομάδα \"{team}\"",
          "FAILED": "Αδυναμία αντιστοίχισης ομάδας. Παρακαλώ δοκιμάστε ξανά."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Υπογραφή μηνύματος",
      "ENABLE_SIGN_TOOLTIP": "Ενεργοποίηση υπογραφής",
      "DISABLE_SIGN_TOOLTIP": "Απενεργοποίηση υπογραφής",
      "MSG_INPUT": "Shift + enter για νέα γραμμή. Ξεκινήστε με '/' για να επιλέξτε Τυποποιημένη Απάντηση.",
      "PRIVATE_MSG_INPUT": "Shift + enter για νέα γραμμή. Το κείμενο θα μπορούν να το δουν μόνο οι υπόλοιποι πράκτορες.",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Δεν έχει ρυθμιστεί η υπογραφή μηνύματος, παρακαλώ ρυθμίστε την στις ρυθμίσεις προφίλ.",
      "CLICK_HERE": "Πατήστε εδώ για ενημέρωση",
      "WHATSAPP_TEMPLATES": "Πρότυπα Whatsapp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "Το 24ωρο παράθυρο του WhatsApp έληξε. Απαντήστε με ένα πρότυπο μήνυμα.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Η απάντησή σας φαίνεται να είναι στα {draftLanguage}, αλλά αυτή η συνομιλία είναι στα {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Μετάφραση",
      "REPLY": "Απάντηση",
      "PRIVATE_NOTE": "Ιδιωτική Σημείωση",
      "SEND": "Αποστολή",
      "CREATE": "Σημείωση (Add Note)",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_FORMAT_ICON": "Προβολή επεξεργαστή εμπλουτισμένου κειμένου",
      "HEADING_LEVEL": {
        "LABEL": "Στυλ κειμένου",
        "NORMAL": "Κανονικό κείμενο",
        "H1": "Επικεφαλίδα 1",
        "H2": "Επικεφαλίδα 2",
        "H3": "Επικεφαλίδα 3"
      },
      "EDITOR": {
        "BOLD": "Έντονα",
        "ITALIC": "Πλάγια",
        "UNDERLINE": "Υπογράμμιση",
        "TEXT_COLOR": "Χρώμα κειμένου",
        "BG_COLOR_LABEL": "Χρώμα φόντου",
        "FONT_SIZE_LABEL": "Μέγεθος γραμματοσειράς",
        "FONT_SIZE": {
          "XS": "Μικρό",
          "SM": "Μεσαίο μικρό",
          "MD": "Προεπιλογή",
          "LG": "Μεγάλο",
          "XL": "Πολύ μεγάλο",
          "XXL": "Τεράστιο"
        },
        "CODE": "Κώδικας",
        "LINK": "Προσθήκη ή αφαίρεση συνδέσμου",
        "CREATE_LINK": "Δημιουργία συνδέσμου",
        "SAVE_LINK": "Αποθήκευση",
        "CANCEL": "Ακύρωση",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Αναίρεση",
        "REDO": "Επανάληψη",
        "BULLET_LIST": "Λίστα με κουκκίδες",
        "ORDERED_LIST": "Αριθμημένη λίστα",
        "BLOCKQUOTE": "Παράθεση",
        "H1": "Επικεφαλίδα 1",
        "H2": "Επικεφαλίδα 2",
        "H3": "Επικεφαλίδα 3",
        "IMAGE_UPLOAD": "Μεταφόρτωση εικόνας",
        "CLEAR_FORMATTING": "Απαλοιφή μορφοποίησης",
        "COLOR": {
          "RED": "Κόκκινο",
          "YELLOW": "Κίτρινο",
          "BLUE": "Μπλε",
          "ROSE_RED": "Ροζ κόκκινο",
          "DEEP_CYAN": "Βαθύ κυανό",
          "ORANGE": "Πορτοκαλί",
          "PISTACHIO": "Φιστικί",
          "PURPLE": "Μοβ",
          "FUCHSIA": "Φούξια",
          "SILVER": "Ασημί",
          "NAVY": "Μπλε ναυτικού",
          "OLD_PINK": "Παλιό ροζ",
          "AQUA": "Γαλαζοπράσινο",
          "BROWN": "Καφέ",
          "OLIVE": "Ελιά",
          "GOLD": "Χρυσό",
          "BEIGE": "Μπεζ",
          "WINE": "Μπορντό",
          "FOREST": "Πράσινο δάσους",
          "GREEN": "Πράσινο",
          "BLUE_GREY": "Μπλε γκρι",
          "RUBY_RED": "Κόκκινο ρουμπινί",
          "CHESTNUT_BROWN": "Καστανό",
          "ASH_GREY": "Σταχτί"
        },
        "BG_COLOR": {
          "RED": "Κόκκινο",
          "YELLOW": "Κίτρινο",
          "BLUE": "Μπλε",
          "ROSE_RED": "Ροζ κόκκινο",
          "DEEP_CYAN": "Βαθύ κυανό",
          "ORANGE": "Πορτοκαλί",
          "PISTACHIO": "Φιστικί",
          "PURPLE": "Μοβ",
          "FUCHSIA": "Φούξια",
          "SILVER": "Ασημί",
          "NAVY": "Μπλε ναυτικού",
          "OLD_PINK": "Παλιό ροζ",
          "AQUA": "Γαλαζοπράσινο",
          "BROWN": "Καφέ",
          "OLIVE": "Ελιά",
          "GOLD": "Χρυσό",
          "BEIGE": "Μπεζ",
          "WINE": "Μπορντό",
          "FOREST": "Πράσινο δάσους",
          "GREEN": "Πράσινο",
          "BLUE_GREY": "Μπλε γκρι",
          "RUBY_RED": "Κόκκινο ρουμπινί",
          "CHESTNUT_BROWN": "Καστανό",
          "ASH_GREY": "Σταχτί"
        }
      },
      "TIP_EMOJI_ICON": "Προβολή επιλογέα emoji",
      "TIP_ATTACH_ICON": "Επισύναψη αρχείων",
      "TIP_AUDIORECORDER_ICON": "Εγγραφή ήχου",
      "TIP_AUDIORECORDER_PERMISSION": "Να επιτρέπεται η πρόσβαση στον ήχο",
      "TIP_AUDIORECORDER_ERROR": "Αδυναμία ανοίγματος ήχου",
      "DRAG_DROP": "Σύρετε και αφήστε εδώ για επισύναψη",
      "START_AUDIO_RECORDING": "Έναρξη ηχογράφησης",
      "STOP_AUDIO_RECORDING": "Διακοπή ηχογράφησης",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Προσθήκη bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Emails διαχωρισμένα με κόμματα",
          "ERROR": "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Emails διαχωρισμένα με κόμματα",
          "ERROR": "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Αποστολή",
          "CANCEL": "Άκυρο"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Προσθέστε ένα κιβώτιο εισερχομένων SMS για να στέλνετε απαντήσεις SMS.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Ιδιωτική Σημείωση: Ορατή μόνο σε σας και την ομάδα σας",
    "CHANGE_STATUS": "Η κατάσταση της συνομιλίας άλλαξε",
    "CHANGE_STATUS_FAILED": "Η αλλαγή κατάστασης συνομιλίας απέτυχε",
    "CHANGE_AGENT": "Η εκπροσώπηση για την συνομιλία άλλαξε",
    "CHANGE_AGENT_FAILED": "Η αλλαγή της ανάθεσης απέτυχε",
    "ASSIGN_LABEL_SUCCESFUL": "Επιτυχής εκχώρηση ετικέτας",
    "ASSIGN_LABEL_FAILED": "Η εκχώρηση ετικέτας απέτυχε",
    "CHANGE_TEAM": "Η ομάδα συνομιλίας άλλαξε",
    "FILE_SIZE_LIMIT": "Το αρχείο υπερβαίνει το όριο συνημμένου {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE}",
    "MESSAGE_ERROR": "Δεν είναι δυνατή η αποστολή του μηνύματος, παρακαλώ προσπαθήστε ξανά αργότερα",
    "SENT_BY": "Αποστολή από:",
    "BOT": "Bot",
    "SEND_FAILED": "Δεν ήταν δυνατή η αποστολή μηνύματος! Προσπαθήστε ξανά",
    "TRY_AGAIN": "επανάληψη",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Επιλογή πράκτορα",
      "REMOVE": "Διαγραφή",
      "ASSIGN": "Αντιστοίχιση"
    },
    "CONTEXT_MENU": {
      "COPY": "Αντιγραφή",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Διαγραφή",
      "CREATE_A_CANNED_RESPONSE": "Προσθήκη στις έτοιμες απαντήσεις",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Διαγραφή",
        "CANCEL": "Άκυρο"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Επαφές",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Η συνομιλία έχει επιλυθεί από τον {userName}",
          "CONTACT_RESOLVED": "Η συνομιλία επιλύθηκε από τον {contactName}",
          "OPEN": "Έγινε επαναφορά της συνομιλίας από τον {userName}",
          "PENDING": "Η συνομιλία επισημάνθηκε ως εκκρεμής από τον {userName}",
          "SNOOZED": "Η συνομιλία σημάνθηκε ως \"καθυστερημένη\" (snoozed) από τον {userName}",
          "AUTO_RESOLVED": "Η συνομιλία σημάνθηκε επιλυθείσα από το σύστημα με την παρέλευση {duration} ημερών άνευ δραστηριότητας",
          "SYSTEM_AUTO_OPEN": "System reopened the conversation due to a new incoming message.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Το σύστημα επέλυσε τη συνομιλία επειδή το ticket έκλεισε στο Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} set the priority to {newPriority}",
          "UPDATED": "{userName} changed the priority from {oldPriority} to {newPriority}",
          "REMOVED": "{userName} removed the priority"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "Ο χρήστης {userName} ανέλαβε αυτήν την συνομιλία",
          "ASSIGNED": "Ανατέθηκε στον {assigneeName} από τον {userName}",
          "REMOVED": "Η συνομιλία σημάνθηκε ως μη ανατεθειμένη από τον {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Ανατέθηκε στον {teamName} από τον {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Ανατέθηκε στον {assigneeName} μέσω {teamName} από {userName}",
          "REMOVED": "Από-ανατέθηκε στον {teamName} από {userName}"
        },
        "LABELS": {
          "ADDED": "Ο {userName} πρόσθεσε ετικέτες {labels}",
          "REMOVED": "Ο {userName} αφαίρεσε τις ετικέτες {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "Ο χρήστης {userName} σίγασε την συνομιλία",
        "UNMUTED": "Ο χρήστης {userName} επανάφερε από την σίγαση την συνομιλία",
        "CONTACT_BLOCKED": "{userName} απέκλεισε την επαφή",
        "CONTACT_UNBLOCKED": "{userName} κατήργησε τον αποκλεισμό της επαφής",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Μεταφέρθηκε επειδή οι παραγγελίες της επαφής προέρχονται μόνο από το κατάστημα {storeName} (τελευταία παραγγελία {orderId}), του οποίου το ρομπότ απαντά σε αυτά τα εισερχόμενα.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Η αυτοματοποίηση παραλείφθηκε επειδή η επαφή είναι αποκλεισμένη",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Ο αυτοματισμός \"{ruleName}\" δεν μπόρεσε να μετακινήσει αυτή τη συζήτηση από το κιβώτιο {sourceInboxName} στο κιβώτιο {targetInboxName}, επειδή τα κιβώτια δεν είναι συμβατά.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Ο αυτοματισμός \"{ruleName}\" δεν μπόρεσε να μετακινήσει αυτή τη συζήτηση από το κιβώτιο {sourceInboxName} στο κιβώτιο {targetInboxName}, επειδή η επαφή δεν έχει διεύθυνση email.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Ο αυτοματισμός «{ruleName}» δεν μπόρεσε να στείλει μήνυμα: αυτά τα εισερχόμενα τηλεφώνου δεν μπορούν να στείλουν SMS, επειδή ο λογαριασμός δεν έχει εισερχόμενα SMS. Ο κανόνας απενεργοποιήθηκε και οι διαχειριστές έλαβαν email.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Ο αυτοματισμός «{ruleName}» δεν μπόρεσε να στείλει μήνυμα: από αυτά τα εισερχόμενα δεν είναι δυνατή η αποστολή συνημμένων μέσω SMS. Ο κανόνας απενεργοποιήθηκε και οι διαχειριστές έλαβαν email.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Η μακροεντολή «{macroName}» δεν έστειλε το μήνυμά της: αυτά τα εισερχόμενα τηλεφώνου δεν μπορούν να στείλουν SMS, επειδή ο λογαριασμός δεν έχει εισερχόμενα SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Η μακροεντολή «{macroName}» δεν έστειλε το μήνυμά της: από αυτά τα εισερχόμενα δεν είναι δυνατή η αποστολή συνημμένων μέσω SMS.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Η μακροεντολή «{macroName}» δεν έστειλε το μήνυμά της: η συνομιλία αυτή διαχειρίζεται από το bot. Ανοίξτε πρώτα τη συνομιλία.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Η μακροεντολή «{macroName}» δεν έστειλε το μήνυμά της: αυτό το κιβώτιο έχει σημειωθεί για διαγραφή. Μετακινήστε πρώτα τη συνομιλία σε άλλο κιβώτιο.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Ο αυτοματισμός \"{ruleName}\" έστειλε email στο {contactEmail} σε νέα συζήτηση [#{conversationId}]({conversationPath}) στο κιβώτιο {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Ο αυτοματισμός \"{ruleName}\" ξεκίνησε αυτή τη συζήτηση εξαιτίας της συζήτησης [#{conversationId}]({conversationPath}) στο κιβώτιο {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Ο αυτοματισμός \"{ruleName}\" δεν μπόρεσε να στείλει το μήνυμα σε νέα συζήτηση στο κιβώτιο {inboxName}, επειδή η επαφή δεν έχει διεύθυνση email.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Ο αυτοματισμός \"{ruleName}\" έστειλε SMS στο {contactPhone} σε νέα συζήτηση [#{conversationId}]({conversationPath}) στο κιβώτιο {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Ο αυτοματισμός \"{ruleName}\" δεν μπόρεσε να στείλει το SMS σε νέα συζήτηση στο κιβώτιο {inboxName}, επειδή η επαφή δεν έχει αριθμό τηλεφώνου.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Πράκτορας",
            "CUSTOMER": "Πελάτης"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "απαντήθηκε αλλού, χτύπησε για {duration}",
            "NO_ANSWER": "αναπάντητο, χτύπησε για {duration}",
            "REJECTED": "απορρίφθηκε μετά από χτύπημα {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Επιλύθηκε αυτόματα μετά από {count} ανεπιτυχείς επανακλήσεις",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Η ηχογράφηση κλήσης διαγράφηκε από τον/την {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Αόρατο στον πελάτη",
    "SENT_VIA_EMAIL": "Στάλθηκε στην επαφή και μέσω email ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Αυτό το κιβώτιο έχει σημειωθεί για διαγραφή, επομένως η απάντηση του πελάτη δεν θα φτάσει ποτέ. Μετακινήστε τη συνομιλία σε άλλο κιβώτιο για να απαντήσετε.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Αυτή η επαφή έχει άλλη μία ανοιχτή συζήτηση #{id}",
      "MULTIPLE": "Αυτή η επαφή έχει άλλες ανοιχτές συζητήσεις ({count})",
      "OPEN": "Άνοιγμα",
      "SHOW": "Εμφάνιση"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Ζητήστε από τον πελάτη να μοιραστεί τον αριθμό τηλεφώνου WhatsApp του",
      "PENDING_ACTION": "Το αίτημα πληροφοριών επικοινωνίας εκκρεμεί",
      "STATES": {
        "PENDING": "Αναμονή πληροφοριών επικοινωνίας",
        "SHARED": "Ο αριθμός τηλεφώνου μοιράστηκε",
        "IDENTITY_CONFLICT": "Ο αριθμός τηλεφώνου χρειάζεται έλεγχο"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Στείλτε την μεταγραφή της σινομιλίας",
    "DESC": "Στείλτε ένα αντίγραφο της συνομιλίας στην διεύθυνση email",
    "SUBMIT": "Καταχώρηση",
    "CANCEL": "Άκυρο",
    "SEND_EMAIL_SUCCESS": "Η μεταγραφή της συνομιλίας έχει αποσταλεί επιτυχώς",
    "SEND_EMAIL_ERROR": "Υπήρξε ένα σφάλμα, παρακαλώ προσπαθήστε ξανά",
    "FORM": {
      "SEND_TO_CONTACT": "Στείλτε το αντίγραφο στον πελάτη",
      "SEND_TO_AGENT": "Στείλε το αντίγραφο στον αντιστοιχισμένο πράκτορα",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Στείλε το αντίγραφο σε άλλη διεύθυνση email",
      "EMAIL": {
        "PLACEHOLDER": "Συμπληρώστε μια διεύθυνση email",
        "ERROR": "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Γεια σας 👋, Καλώς ήρθατε στο {installationName}!",
    "DESCRIPTION": "Ευχαριστούμε για την εγγραφή. Θέλουμε να αξιοποιήσετε στο έπακρο το {installationName}. Εδώ είναι μερικά πράγματα που μπορείτε να κάνετε στο {installationName} για να έχετε μια ευχάριστη εμπειρία.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Διαβάστε τις πρόσφατες ενημερώσεις μας",
    "ALL_CONVERSATION": {
      "TITLE": "Όλες οι συνομιλίες σας σε ένα μέρος",
      "DESCRIPTION": "Δείτε όλες τις συνομιλίες από τους πελάτες σας σε ένα μόνο ταμπλό. Μπορείτε να φιλτράρετε τις συνομιλίες κατά εισερχόμενο κανάλι, ετικέτα και κατάσταση.",
      "NEW_LINK": "Κάντε κλικ εδώ για δημιουργία εισερχόμενων"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Προσκαλέστε τα μέλη της ομάδας σας",
      "DESCRIPTION": "Δεδομένου ότι ετοιμάζεστε να συνομιλήσετε με τον πελάτη σας, φέρτε τους συνάδελφους σας για να σας βοηθήσουν. Μπορείτε να προσκαλέσετε τους συνάδελφους σας προσθέτοντας τη διεύθυνση email τους στη λίστα αντιπροσώπων.",
      "NEW_LINK": "Κάντε κλικ εδώ για να καλέσετε ένα μέλος της ομάδας"
    },
    "LABELS": {
      "TITLE": "Οργάνωση συνομιλιών με ετικέτες",
      "DESCRIPTION": "Οι ετικέτες παρέχουν έναν ευκολότερο τρόπο για να κατηγοριοποιήσετε τη συνομιλία σας. Δημιουργήστε μερικές ετικέτες όπως το #support-quiry, #billing-question κλπ., έτσι ώστε να μπορείτε να τις χρησιμοποιήσετε σε μια συζήτηση αργότερα.",
      "NEW_LINK": "Κάντε κλικ εδώ για δημιουργία ετικετών (tags)"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Ανατεθειμένο σε Πράκτορα",
    "SELF_ASSIGN": "Ανάθεση σε μένα",
    "TEAM_LABEL": "Ανατεθειμένο σε Ομάδα",
    "SELECT": {
      "PLACEHOLDER": "Κανένα"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Λεπτομέρειες Επαφής",
      "CONVERSATION_ACTIONS": "Ενέργειες Συνομιλίας",
      "CONVERSATION_LABELS": "Ετικέτες συνομιλίας",
      "CONVERSATION_INFO": "Πληροφορίες Συνομιλίας",
      "CONTACT_ATTRIBUTES": "Ιδιότητες Επαφής",
      "PREVIOUS_CONVERSATION": "Προηγούμενες συνομιλίες",
      "MACROS": "Μακροεντολές",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Εκκρεμεί",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Δημιουργία ιδιότητας",
    "NO_RECORDS_FOUND": "Δεν βρέθηκαν ιδιότητες",
    "UPDATE": {
      "SUCCESS": "Ο πράκτορας ενημερώθηκε επιτυχώς",
      "ERROR": "Δεν είναι δυνατή η ενημέρωση της ιδιότητας. Παρακαλώ προσπαθήστε ξανά αργότερα"
    },
    "ADD": {
      "TITLE": "Προσθήκη",
      "SUCCESS": "Η ιδιότητα προστέθηκε με επιτυχία",
      "ERROR": "Δεν ήταν δυνατή η δημιουργία Ιδιότητας, Παρακαλώ δοκιμάστε ξανά αργότερα"
    },
    "DELETE": {
      "SUCCESS": "Η ιδιότητα προστέθηκε με επιτυχία",
      "ERROR": "Δεν είναι δυνατή η διαγραφή της ιδιότητας. Παρακαλώ δοκιμάστε ξανά αργότερα"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Προσθήκη ιδιότητας",
      "PLACEHOLDER": "Αναζήτηση ιδιοτήτων",
      "NO_RESULT": "Δεν βρέθηκαν ιδιότητες"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Από",
    "TO": "Προς",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Θέμα"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "Δεν βρέθηκαν αποτελέσματα",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Αριθμός παραγγελίας",
    "EXTERNAL_ID": "Εξωτερικό αναγνωριστικό",
    "PAYMENT_TYPE": "Τρόπος πληρωμής",
    "PAYMENT_DATE": "Ημερομηνία πληρωμής",
    "DELIVERY_PROVIDER": "Μεταφορική",
    "EXPECTED_DATE_OF_DELIVERY": "Αναμενόμενη παράδοση",
    "DATE_OF_DELIVERY": "Παραδόθηκε στις",
    "EXPEDITION_DATE": "Ημερομηνία αποστολής",
    "INTERNAL_NOTE": "Σημείωση καταστήματος",
    "PACKAGE_NUMBER": "Αποστολή"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
